import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Building2 } from 'lucide-react';
import { useContent } from '@/hooks/useContent';

gsap.registerPlugin(ScrollTrigger);

const partners = [
  { id: 1, name: 'Insurance Company 1' },
  { id: 2, name: 'Insurance Company 2' },
  { id: 3, name: 'Insurance Company 3' },
  { id: 4, name: 'Insurance Company 4' },
  { id: 5, name: 'Insurance Company 5' },
  { id: 6, name: 'Insurance Company 6' },
];

const Partners = () => {
  const { t } = useContent();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    gsap.fromTo(
      section.querySelectorAll('.partner-logo'),
      {
        opacity: 0.3,
        scale: 0.9,
      },
      {
        opacity: 1,
        scale: 1,
        duration: 0.6,
        stagger: 0.1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
        },
      }
    );
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-20 bg-light-primary dark:bg-dark-primary"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-light-text dark:text-dark-text">
            {t('home.partners.title')}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="partner-logo flex items-center justify-center p-6 bg-light-secondary dark:bg-dark-secondary rounded-xl hover:bg-light-accent dark:hover:bg-dark-accent transition-all duration-300 hover:scale-105 grayscale hover:grayscale-0"
            >
              <Building2
                size={64}
                className="text-light-text-secondary dark:text-dark-text-secondary"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;

